import Icon from 'assets/images/cross.svg'

const RemoveIcon = ({ ...rest }) => (
  <img src={Icon} alt="cross icon" {...rest} />
)

export default RemoveIcon
